import { useEffect } from 'react';

const useTitle = (title) => {
  useEffect(() => {
    document.title = `${title} | CJJ Belgian Federation`;
  }, [title]);
};

export default useTitle;